import { useRouter } from 'next/router';
import { UI_ScriptModule } from 'ui/components/2-molecules/ScriptModule/ScriptModule';

interface Props {
	documentType: 'scriptModule';
	content: {
		properties: {
			script: string;
			heading: string;
		};
	};
	settings: {
		properties: {
			appendLastQuerystring: boolean;
			height?: string;
		};
	};
}

export const ScriptModule = ({ content, settings }: Props) => {
	const { script, heading } = content?.properties ?? {};
	const { appendLastQuerystring, height } = settings?.properties ?? {};
	const router = useRouter();

	const lastQueryParam = router.asPath.includes('?') ? router.asPath.split('?')[1].split('&').pop() : undefined;

	let processedScript = script;
	if (appendLastQuerystring && lastQueryParam) {
		const [paramKey, paramValue] = lastQueryParam.split('=');
		const srcPattern = /src=["']([^"']+)["']/i;
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		const [fullMatch, srcUrlMatch] = script.match(srcPattern) ?? [];
		if (srcUrlMatch) {
			let srcUrlWithPageQueryParam = srcUrlMatch;
			try {
				const url = new URL(srcUrlMatch);
				url.searchParams.set(paramKey, paramValue);
				srcUrlWithPageQueryParam = url.toString();
			} catch {
				// If URL parsing fails, keep original
			}

			processedScript = script.replace(srcUrlMatch, srcUrlWithPageQueryParam);
		}
	}

	return <UI_ScriptModule script={processedScript} heading={heading} height={height} />;
};
